import NotificationActions from '../../../actions/NotificationActions';
import UserStore from '../../../stores/UserStore';
import AjaxPromises from '../../../utils/AjaxPromises';
import { endPoints as GuestEndPoints } from '../../../constants/GuestConstants';
import DOB from '../../form/DOB.react';
import moment from 'moment';

class BirthdateCheckModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            birthdate: ''
        };

        this.submitBirthdate = this.submitBirthdate.bind(this);
    }

    validateDob(value) {
        const guestDob = moment(this.props.guest.DOB).startOf('day');
        const isAnonymous = this.props.guest.IsAnonymous;
        const valueDate = moment(value).startOf('day');

        if (isAnonymous) {
            return true;
        } else if (!valueDate.isValid()) {
            NotificationActions.error('Please provide a date of birth');
            return false;
        } else if (!guestDob.isValid()) {
            NotificationActions.error('No date of birth set on customer profile');
            return false;
        } else if (valueDate.diff(guestDob) !== 0) {
            NotificationActions.error('Date of birth does not match customer profile');
            return false;
        } else {
            return true;
        }
    }

    submitBirthdate() {
        if (this.state.loading || !this.isValid()) {
            return;
        }

        if(!!this.props.guest) {
            if (!this.validateDob(this.state.birthdate)) {
                return;
            }
        }

        var acctId = null;
        if(this.props.guest) {
            acctId = this.props.guest.Guest_id
        }

        this.setState({ loading : true });
        AjaxPromises.POST(GuestEndPoints.VERIFY_CUSTOMER_BIRTHDAY, UserStore.getApiData({
            ShipmentId : this.props.ShipmentId,
            AcctId: acctId,
            Birthdate: this.state.birthdate
        })).then(res => {
            if (res.Result) {
                this.props.onClose(true);
                NotificationActions.success('Birthdate Valid');
            } else {
                NotificationActions.error(res.Message);
            }
            this.setState({loading : false});
        }).catch(err => {
            NotificationActions.error('Validation failed')
            this.setState({loading : false});
        });
        
    }

    isValid() {
        return moment(this.state.birthdate).isValid();
    }

    render() {
        return (
            <div className='popup popup__transparent'>
                <div className='popup__content checkout' style={{  
                    width: '250px',
                    height: '200px',
                    }}>
                    <div className='popup-header'>
                        Enter Birthdate
                        <div className='popup-close'
                            onClick={() => {  this.props.onClose(false); }}>
                            <i className="fa fa-times" aria-hidden="true" />
                        </div>
                    </div>
                    <div style={{
                        textAlign: 'center',
                        padding: '10px',
                    }}>
                        <DOB
                            AllowInFuture
                            value={this.state.birthdate}
                            onChange={(field, value) => { this.setState({ birthdate : value }); }}
                            className='back-date__input' />
                        <div className={'view-policy__buttons'} style={{ paddingTop: '20px'}}>
                            <div
                                class={'btn-green ' + (!this.isValid() ? 'btn-green__disabled' : '')}
                                style={{ position:'absolute', right: '20px'}}
                                onClick={this.submitBirthdate}>
                                { !this.state.loading && 'SAVE' }
                                { this.state.loading && <i className='fa fa-spinner fa-pulse' />  }
                            </div>
                            <div class="btn-green"
                                style={{ position:'absolute', left: '20px'}}
                                onClick={() => { this.props.onClose(false); }}>
                                CANCEL
                            </div>
                        </div>
                    </div>
                </div>     
            </div>
        );
    }
}

export default BirthdateCheckModal;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/checkout/BrithdateCheckModal.jsx